import {formatTime} from "@/libs/helper";

export const NeoSwipeVehicleTiming: React.FC<any> = ({data, uid}) => {
  //console.log(data, uid);
  const swipeLocation = data[uid] || [];

  const convertTime = (timestamp: number) => {
    return formatTime(timestamp);
  };
  return (
    <>
      <div className="flex flex-col gap-1">
        {swipeLocation.map((entry: any, index: any) => {
          const formattedTimes = entry.swipes.length
            ? entry.swipes.map(convertTime).join(", ")
            : "No swipes";
          return (
            <div key={index}>
              {entry.vehicle} ({formattedTimes})
            </div>
          );
        })}
      </div>
    </>
  );
};
